import { IMG } from "./images";
import { VEHICLE_PREFERENCES, TRAVELLER_SEATS } from "./site";

// Reference vehicle categories. Published model tariffs guide the trip quote;
// availability, vehicle assignment and luggage fit are confirmed on enquiry.
// Images are representative category illustrations, not photos of specific owned vehicles.
// `name` matches the form's vehicle category so fleet buttons preselect correctly.
export const FLEET = [
  {
    id: "sedan",
    name: "Sedan",
    category: "4-door car",
    examples: VEHICLE_PREFERENCES.Sedan.filter(model => model !== "No preference").join(", "),
    capacityNote: "Capacity confirmed on quote — tell us your group size",
    image: IMG.carSedan,
    representative: true,
    alt: "Representative white sedan car for city and outstation travel",
    bestFor:
      "Satna city runs, railway station drops, couples and small-family outstation journeys.",
    features: ["City & station trips", "Outstation enquiries", "Confirm seating", "Confirm luggage fit"],
  },
  {
    id: "suv-mpv",
    name: "SUV / MPV",
    category: "Family vehicle",
    examples: VEHICLE_PREFERENCES["SUV / MPV"].filter(model => model !== "No preference").join(", "),
    capacityNote: "Capacity confirmed on quote — tell us your group size",
    image: IMG.carSuv,
    representative: true,
    alt: "Representative white SUV / MPV for family and group travel",
    bestFor:
      "Family trips and longer highway journeys to Khajuraho, Bandhavgarh, Bhopal, Indore and Varanasi.",
    features: ["Family travel", "Planned outstation trips", "Confirm luggage fit", "Confirm AC details"],
  },
  {
    id: "tempo-traveller",
    name: "Tempo Traveller",
    category: "Group travel",
    examples: TRAVELLER_SEATS.join(", ") + " seater options",
    capacityNote: "13, 17, 20, 21 and 26 total seats include one driver. The 9-seater layout and price are confirmed on request.",
    image: IMG.tempo,
    representative: true,
    alt: "Representative white Force Tempo Traveller minibus for group travel",
    bestFor:
      "Pilgrimage groups, wedding guests, corporate outings and multi-day Madhya Pradesh tours.",
    features: ["Group travel", "Multi-stop itineraries", "Confirm seat layout", "Confirm luggage fit"],
  },
];
